import SummaryItem, {
  type SummaryItemProps,
} from "@/screens/loans/components/SummaryItem"
import { View } from "react-native"
import { Vertical, Horizontal } from "@/components/standard/BFLayout"
import { H4 } from "@/components/standard/BFText"
import EditButton from "@/components/buttons/EditButton"
import React from "react"
import ToolLine from "@/components/util/ToolLine"
import { BFLink } from "@/components/buttons/Links"

interface SummaryLink {
  label: string
  url: string
}

interface SummarySectionProps {
  onEdit?: () => void
  title: string
  items: SummaryItemProps[]
  toolLineIndex?: number // index at which to insert a ToolLine
  links?: SummaryLink[] // array of link objects to display below everything
}

export const SummarySection = ({
  title,
  onEdit,
  items,
  toolLineIndex,
  links,
}: SummarySectionProps) => {
  return (
    <Vertical>
      <View className="flex-row items-center justify-between my-2">
        <H4 className="text-midnight-blue">{title}</H4>
        {onEdit && <EditButton onPress={onEdit} />}
      </View>

      <View className="flex flex-col bg-grey border border-light-grey rounded p-4 py-2">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {toolLineIndex === index && (
              <ToolLine key={`toolline-${index}`} className={"my-3"} />
            )}
            <SummaryItem tight={true} {...item} />
          </React.Fragment>
        ))}
        {links && links.length > 0 && (
          <Horizontal className="justify-between items-center mt-5 mb-4">
            {links.map((link, idx) => (
              <BFLink
                key={idx}
                testId={`summary-section-link-${idx}`}
                url={link.url}
                size="sm"
                showsIcon={true}
                text={link.label}
              />
            ))}
          </Horizontal>
        )}
      </View>
    </Vertical>
  )
}
